import { documentationActions } from './constant';

const {
  REQUEST_GET_ALL_TEMPLATES,
  REQUEST_CALL_SUBMISSION_EVENT,
  RESET_CALL_SUBMISSION_EVENT,
  REQUEST_GET_ALL_SUBMITTED_DOCUMENT,
  REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER,
  REQUEST_GET_ALL_COMPETED_DOCUMENT,
  REQUEST_SUBMITTED_DATA_BY_SUBMISSION_ID,
  RESET_SUBMITTED_DATA_BY_SUBMISSION_ID,
  REQUEST_GET_SIGNATURE_TEMPLATE,
  REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS,
  REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS,
  RESET_SAVE_MISCELLANEOUS_DOCUMENTS,
  REQUEST_GET_ALL_SUPERVISIORS,
  REQUEST_EDIT_SIGN_DOC,
  RESET_EDIT_SIGN_DOC,
  REQUEST_SEND_MAIL_TO_PHYSICIAN,
  RESET_SEND_MAIL_TO_PHYSICIAN,
  REQUEST_GET_ALL_CODES,
  REQUEST_GET_SIGNATURE_ACCESS,
  RESET_GET_SIGNATURE_ACCESS,
  REQUEST_GET_ALL_CODES_ICD,
  PULL_UUID_REQUEST,
  PULL_UUID_RESET,
  REQUEST_REASSIGN_THERAPIST,
  RESET_REASSIGN_THERAPIST,
  REQUEST_GET_PROVIDER_LIST,
  REQUEST_LOADING_DOCUMENTATION,
  SUCCESS_LOADING_DOCUMENTATION,
  RESET_LOADING_DOCUMENTATION,
  ERROR_LOADING_DOCUMENTATION,
  REQUEST_GET_DOC_PREFILL_URL,
  RESET_GET_DOC_PREFILL_URL,
  RESET_GET_SIGNATURE_TEMPLATE,
  REQUEST_DAILY_SESSION_NOTES_SIGN,
  RESET_GET_ALL_SUBMITTED_DOCUMENT,
  GET_START_OF_CARE_DATE_RESET,
  GET_START_OF_CARE_DATE_REQUEST,
  REQUEST_DELETE_REQUIRED_DOCUMET,
  RESET_DELETE_REQUIRED_DOCUMET,
  REQUEST_PREPARE_PROGREE_NOTE,
  RESET_PREPARE_PROGREE_NOTE,
  GET_DASHBOARD_DOCUMENT_DATA,
  RESET_DASHBOARD_DOCUMENT_DATA,
  SET_NAVIGATION_FORM,
  GET_EOC_CREATE_DOCUMENT_DATA,
  RESET_EOC_CREATE_DOCUMENT_DATA,
  RESET_EOC_EDIT_DOCUMENT_DATA,
  GET_EOC_EDIT_DOCUMENT_DATA,
  RESET_NAVIGATION_FORM,
  IS_CHECK_DOCUMENT_REFORM,
  CHECK_DISCHARGE_ALLOWS_REQUEST,
  CHECK_DISCHARGE_ALLOWS_RESET,
  CHECK_PENDING_DOCS_ALERT_REQUEST,
  CHECK_PENDING_DOCS_ALERT_RESET,
  NEW_DOCUMENT_SIGN_REQUEST,
  NEW_DOCUMENT_SIGN_RESET,
  UNDO_DOCUMENT_SIGN_REQUEST,
  UNDO_DOCUMENT_SIGN_RESET,
  REQUEST_DUE_DOCUMENT_SETTING_REQUEST,
  REQUEST_DUE_DOCUMENT_SETTING_RESET,
} = documentationActions;

type GetAllSubmittedDocuments = {
  therapistUuid: string | boolean | string[] | null;
  eocId: string;
  params: object;
  signal: any;
  disciplineChange?: boolean;
};

export const setNavigationPathAction = (payload: any) => {
  return {
    type: SET_NAVIGATION_FORM,
    payload,
  };
};

export const checkIsReformAction = (payload: any) => {
  return {
    type: IS_CHECK_DOCUMENT_REFORM,
    payload,
  };
};

export const resetNavigationPath = () => {
  return {
    type: RESET_NAVIGATION_FORM,
  };
};

export const getAllTemplates = (payload: object) => {
  return {
    type: REQUEST_GET_ALL_TEMPLATES,
    payload,
  };
};

export const callSubmitEventAction = (payload: object, params: object = {}) => {
  return {
    type: REQUEST_CALL_SUBMISSION_EVENT,
    payload,
    params,
  };
};

export const resetSubmissionEventAction = () => {
  return {
    type: RESET_CALL_SUBMISSION_EVENT,
  };
};

export const getAllSubmittedDocument = (payload: GetAllSubmittedDocuments) => {
  return {
    type: REQUEST_GET_ALL_SUBMITTED_DOCUMENT,
    payload,
  };
};

export const getAllSubmittedDocs = (payload: GetAllSubmittedDocuments) => {
  return {
    type: REQUEST_GET_ALL_SUBMITTED_DOCUMENT_FOR_RESOLVER,
    payload,
  };
};

export const getAllCompletedDocAction = (payload: GetAllSubmittedDocuments) => {
  return {
    type: REQUEST_GET_ALL_COMPETED_DOCUMENT,
    payload,
  };
};

export const getAllSubmittedDocumentReset = () => {
  return {
    type: RESET_GET_ALL_SUBMITTED_DOCUMENT,
  };
};

export const getSubmissionDataBySubmissionId = (payload: string) => {
  return {
    type: REQUEST_SUBMITTED_DATA_BY_SUBMISSION_ID,
    payload,
  };
};

export const resetGetSubmissionData = () => {
  return {
    type: RESET_SUBMITTED_DATA_BY_SUBMISSION_ID,
  };
};

export const getSignatureTemplate = (payload: object) => {
  return {
    type: REQUEST_GET_SIGNATURE_TEMPLATE,
    payload,
  };
};

export const getAllMiscDocumentAction = (payload: any) => {
  return {
    type: REQUEST_GET_ALL_MISCELLANEOUS_DOCUMENTS,
    payload,
  };
};

export const saveMiscDocumentAction = (payload: any) => {
  return {
    type: REQUEST_SAVE_MISCELLANEOUS_DOCUMENTS,
    payload,
  };
};

export const resetSaveMiscDocumentAction = () => {
  return {
    type: RESET_SAVE_MISCELLANEOUS_DOCUMENTS,
  };
};

export const getAllSupervisiorByDiscipline = (payload: object) => {
  return {
    type: REQUEST_GET_ALL_SUPERVISIORS,
    payload,
  };
};

export const editSignDocAction = (documentUuid: string, payload: object) => {
  return {
    type: REQUEST_EDIT_SIGN_DOC,
    documentUuid,
    payload,
  };
};

export const resetEditSigndocAction = () => {
  return {
    type: RESET_EDIT_SIGN_DOC,
  };
};

export const sendMailToPhysicianAction = (supervisiorUuid: string, payload: object) => {
  return {
    type: REQUEST_SEND_MAIL_TO_PHYSICIAN,
    supervisiorUuid,
    payload,
  };
};

export const resetSendMailToPhysician = () => {
  return {
    type: RESET_SEND_MAIL_TO_PHYSICIAN,
  };
};

export const getAllCodesAction = (payload: object, patientUuid: string) => {
  return {
    type: REQUEST_GET_ALL_CODES,
    payload,
    patientUuid,
  };
};

export const getAllICDAction = (payload: object, patientUuid: string) => {
  return {
    type: REQUEST_GET_ALL_CODES_ICD,
    payload,
    patientUuid,
  };
};

export const getSignatureAccessAction = (payload: Array<String>, params: object) => {
  return {
    type: REQUEST_GET_SIGNATURE_ACCESS,
    payload,
    params,
  };
};

export const resetSignatureAccess = () => {
  return {
    type: RESET_GET_SIGNATURE_ACCESS,
  };
};

export const resetStartOfCareDate = () => {
  return {
    type: GET_START_OF_CARE_DATE_RESET,
  };
};

export const pullUuidAction = (payload: object, params = {}) => {
  return {
    type: PULL_UUID_REQUEST,
    payload,
    params,
  };
};

export const resetUuidAction = () => {
  return {
    type: PULL_UUID_RESET,
  };
};

export const reAssignTherapistAction = (documentUuid: string, providerId: string) => {
  return {
    type: REQUEST_REASSIGN_THERAPIST,
    documentUuid,
    providerId,
  };
};

export const resetreAssignTherapistAction = () => {
  return {
    type: RESET_REASSIGN_THERAPIST,
  };
};

export const getAllTherapistAction = (
  discipline: string | null | undefined,
  role: string | null | undefined,
  therapistId: string | boolean | string[] | null
) => {
  return {
    type: REQUEST_GET_PROVIDER_LIST,
    discipline,
    role,
    therapistId,
  };
};

export const requestForLoaderDocumentation = (payload: string) => {
  return {
    type: REQUEST_LOADING_DOCUMENTATION,
    payload,
  };
};

export const successForLoaderDocumentation = (payload: string) => {
  return {
    type: SUCCESS_LOADING_DOCUMENTATION,
    payload,
  };
};

export const resetForLoaderDocumentation = () => {
  return {
    type: RESET_LOADING_DOCUMENTATION,
  };
};

export const errorForLoaderDocumentation = (payload: string) => {
  return {
    type: ERROR_LOADING_DOCUMENTATION,
    payload,
  };
};

export const getPrefillUrlAction = (uuid: string, payload: object) => {
  return {
    type: REQUEST_GET_DOC_PREFILL_URL,
    uuid,
    payload,
  };
};

export const resetGetPrefillUrlAction = () => {
  return {
    type: RESET_GET_DOC_PREFILL_URL,
  };
};

export const resetDashboardDocumentESign = () => {
  return {
    type: RESET_GET_SIGNATURE_TEMPLATE,
  };
};

export const checkDailySessionNoteSign = (payload: any) => {
  return {
    type: REQUEST_DAILY_SESSION_NOTES_SIGN,
    payload,
  };
};

export const getPrefillStartOfCareDate = (payload: any) => {
  return {
    type: GET_START_OF_CARE_DATE_REQUEST,
    payload,
  };
};

export const deleteRequiredDocumentAction = (documentUuid: string) => {
  return {
    type: REQUEST_DELETE_REQUIRED_DOCUMET,
    documentUuid,
  };
};

export const resetDeleteRequiredDocumentAction = () => {
  return {
    type: RESET_DELETE_REQUIRED_DOCUMET,
  };
};

export const getPrepareProgressNoteAction = (episodeOfCareId: string, params: object) => {
  return {
    type: REQUEST_PREPARE_PROGREE_NOTE,
    episodeOfCareId,
    params,
  };
};

export const resetPrepareProgressNoteAction = () => {
  return {
    type: RESET_PREPARE_PROGREE_NOTE,
  };
};

export const getTherapistDocumentCreateEditDataAction = (payload: any) => {
  return {
    type: GET_DASHBOARD_DOCUMENT_DATA,
    payload,
  };
};

export const resetTherapistDocumentCreateEditDataAction = () => {
  return {
    type: RESET_DASHBOARD_DOCUMENT_DATA,
  };
};

export const getEocDocumentCreateDataAction = (payload: any) => {
  return {
    type: GET_EOC_CREATE_DOCUMENT_DATA,
    payload,
  };
};

export const resetEocDocumentCreateDataAction = () => {
  return {
    type: RESET_EOC_CREATE_DOCUMENT_DATA,
  };
};

export const getEocDocumentEditDataAction = (payload: any) => {
  return {
    type: GET_EOC_EDIT_DOCUMENT_DATA,
    payload,
  };
};

export const resetEocDocumentEditDataAction = () => {
  return {
    type: RESET_EOC_EDIT_DOCUMENT_DATA,
  };
};

export const checkDischargeDocAction = (payload: any) => {
  return {
    type: CHECK_DISCHARGE_ALLOWS_REQUEST,
    payload,
  };
};

export const resetCheckDischargeDoc = () => {
  return {
    type: CHECK_DISCHARGE_ALLOWS_RESET,
  };
};

export const checkPendingDocsAlertAction = (payload: any) => {
  return {
    type: CHECK_PENDING_DOCS_ALERT_REQUEST,
    payload,
  };
};

export const resetPendingDocsAlertAction = () => {
  return {
    type: CHECK_PENDING_DOCS_ALERT_RESET,
  };
};

export const newDocumentSignAction = (payload: any) => {
  return {
    type: NEW_DOCUMENT_SIGN_REQUEST,
    payload,
  };
};

export const resetNewDocumentSignAction = () => {
  return {
    type: NEW_DOCUMENT_SIGN_RESET,
  };
};

export const undoDocumentSignAction = (payload: any) => {
  return {
    type: UNDO_DOCUMENT_SIGN_REQUEST,
    payload,
  };
};

export const resetUndoDocumentSignAction = () => {
  return {
    type: UNDO_DOCUMENT_SIGN_RESET,
  };
};

export const requestDocDueSettings = (payload: any) => {
  return {
    type: REQUEST_DUE_DOCUMENT_SETTING_REQUEST,
    payload,
  };
};

export const resetDocDueSettings = (payload: any) => {
  return {
    type: REQUEST_DUE_DOCUMENT_SETTING_RESET,
    payload,
  };
};



